import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { DataService } from '../../services/data_service';
import { EinstellungBeraterButtonWrapper } from './assistent/items/wrapper/EinstellungBeraterButtonWrapper';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { showKostenKonfiguration } from '../../helpers/showKosten';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeBetrieblicheDatenKonfigurationProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    gefuehrterModus: boolean;
}

interface DateneingabeBetrieblicheDatenKonfigurationState extends React.ClassAttributes<any> {
    showEditBerater: boolean;
    beraterZugriff: number;
    keyAddon: number;
}

export class DateneingabeBetrieblicheDatenKonfiguration extends React.Component<DateneingabeBetrieblicheDatenKonfigurationProps,
    DateneingabeBetrieblicheDatenKonfigurationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showEditBerater: false,
            beraterZugriff: 1,
            keyAddon: 0
        };
        this.customValidate = this.customValidate.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.setBeraterZugriff();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        // console.log('KONFIG GF: ', this.props.gefuehrterModus, prevProps.gefuehrterModus );
        if (this.props.gefuehrterModus !== prevProps.gefuehrterModus) {
            this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
        }
        if (prevState.beraterZugriff === this.state.beraterZugriff) {
            this.setBeraterZugriff(true);
        }
    }

    setBeraterZugriff(setKeyAddon = false): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION][0]) {
            const beraterZugriff = +data[IDs.ENT_KONFIGURATION][0].berater_zugriff_orig;
            if (beraterZugriff !== this.state.beraterZugriff) {
                this.setState({ beraterZugriff });
                if (setKeyAddon) {
                    this.setState({ keyAddon: this.state.keyAddon + 1 });
                }
            }
        }
    }

    render(): JSX.Element {
        const { beraterZugriff, keyAddon } = this.state;
        const bereichKey: string = this.apiService.getBereichKey();
        const devFeatures: boolean = config.devFeatures || false;
        const isAdmin = this.apiService.isAdmin(); // || this.apiService.getUsername() === 'yang.wang@wips-home.de' /* zum Test */;
        const konfData: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const styleAdminOnly: React.CSSProperties = { color: '#aaa' };
        const tid: number = Array.isArray(konfData) && konfData.length > 0 ? konfData[0].tid : 0;

        /*if (!tid) {
            return <div>Lade ...</div>;
        }*/
       

        const item = tid > 0 ? konfData[0] : undefined;
        const alternatives_system: number = (item || {}).alternatives_system_orig || (item || {}).alternatives_system || 0;
        const formPreset: any = {};
        const customFormConfig: any = {
            energiesteuerrueckerstattung: { hidden: true },
            gelesene_hinweise_ausblenden: { hidden: true },
            unternehmensart: { hidden: true },
            plz: { hidden: true },
            externer_berater: { hidden: true }
        };
        const customCssStyle: any = {
            formField: {
                startjahr_datenerfassung: {
                    classInput: { width: 200 }
                },
                berater_zugriff: {
                    classInput: { paddingBottom: 0 }
                }
            },
            formFieldSelect: {
                classInput: { maxWidth: 'calc(100% - 30px)' }
            },
            formcontainer: { marginLeft: 10 },
            formTitel: {
                fontStyle: 'italic',
                fontWeight: 'normal',
                textAlign: 'left',
                textDecoration: 'underline',
                color: '#4472c4',
                backgroundColor: 'inherit',
                marginBottom: 10,
                padding: 0
            },
            label: {
                etool_test: styleAdminOnly,
                auto_save_intervall: styleAdminOnly,
                vsme: styleAdminOnly
            }
        };

        if (+(item || {}).startjahr_datenerfassung > 2014) {
            customFormConfig.startjahr_datenerfassung = { hidden: !isAdmin };
            customCssStyle.label.startjahr_datenerfassung = isAdmin ? styleAdminOnly : {};
        }
        if (item && item.mehrere_standorte_orig && +item.mehrere_standorte_orig !== 1) {
            customFormConfig.daten_kraftstoffe_standort = { hidden: true };
        }

        if (!isAdmin) {
            customFormConfig.etool_test = { hidden: true };
        }
        // Siehe getAssistentConfigKonfig()
        // const co2_fussabdruck_flag = konfData.length > 0 && konfData[0].co2_fussabdruck_orig === 1;
        const co2_fussabdruck_modus_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
        const handwerk_flag: boolean = bereichKey === 'handwerk';
        const kultur_flag: boolean = bereichKey === 'kultur';
        const privat_flag: boolean = bereichKey === 'privat';
        const showKosten: boolean = showKostenKonfiguration(this.props.data);
        if (alternatives_system !== 1 || kultur_flag || privat_flag) {
            customFormConfig.alternatives_system = { hidden: !isAdmin };
            customCssStyle.label.alternatives_system = isAdmin ? styleAdminOnly : {};
        }
        customFormConfig.co2_fussabdruck_modus = {
            // WKETOOL-69: 371
            readonly: kultur_flag,
            label: !kultur_flag ? 'Möchten Sie statt der kompakten Datenerfassung lieber detaillierte Datenerfassung nutzen?' : undefined,
            bundle_text: !kultur_flag ? 'name2' : undefined,
            hidden: kultur_flag /* !co2_fussabdruck_flag && kultur_flag */
        };
        customFormConfig.mehrere_standorte = { hidden: privat_flag };
        customFormConfig.daten_maschinen = { hidden: privat_flag };
        customFormConfig.co2_fussabdruck_sachanlagen = { hidden: /*!co2_fussabdruck_flag || */!co2_fussabdruck_modus_ghg || privat_flag };
        customFormConfig.auto_save_intervall = { hidden: !isAdmin };
        customFormConfig.veranstaltungen = { hidden: !kultur_flag };
        // customFormConfig.alternatives_system = { hidden: kultur_flag || privat_flag };
        customFormConfig.vsme = { hidden: !isAdmin || (isAdmin && privat_flag) };
        customFormConfig.vorsteuerabzugsberechtigt = { hidden: handwerk_flag || privat_flag };
        customFormConfig.berater_zugriff = { hidden: privat_flag };
        customFormConfig.anwendungskontext = { hidden: privat_flag };
        customFormConfig.kosten_erfassen = { hidden: !showKosten/*!devFeatures*/ };

        const modulSelected: string = (this.props.data || {}).MODUL_SELECTED;
        if (modulSelected === 'classic') {
            customFormConfig.co2_fussabdruck_modus = { hidden: true };
        } else if (modulSelected === 'cfm') {
            customFormConfig.daten_fahrzeuge = { hidden: true };
            customFormConfig.daten_maschinen = { hidden: true };
            customFormConfig.co2_fussabdruck_modus = { hidden: true };
            customFormConfig.co2_fussabdruck_sachanlagen = { hidden: false };
            customFormConfig.anwendungskontext = { hidden: true };
            customFormConfig.alternatives_system = { hidden: true };
        } else if (modulSelected === 'steuer') {
            customFormConfig.energiesteuerrueckerstattung = { hidden: false };
            customFormConfig.datenerfassung = { hidden: true };
            customFormConfig.daten_erneuerbare_energien = { hidden: true };
            customFormConfig.daten_fahrzeuge = { hidden: true };
            customFormConfig.daten_maschinen = { hidden: true };
            customFormConfig.erweiterte_funktionen = { hidden: true };
            customFormConfig.co2_fussabdruck = { hidden: true };
            customFormConfig.co2_fussabdruck_modus = { hidden: true };
            customFormConfig.co2_fussabdruck_sachanlagen = { hidden: true };
            customFormConfig.anwendungskontext = { hidden: true };
            customFormConfig.alternatives_system = { hidden: true };
        } else if (modulSelected === 'vsme') {
            customFormConfig.co2_fussabdruck_modus = { hidden: true };
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'row', flex: 1/*, minHeight: 0*/ }}>
                <div
                    style={{
                        display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', maxWidth: 600
                    }}
                >
                    <WFormsTableWrapper
                        refreshStamp={new Date().getTime()}
                        key={'DateneingabeKonfiguration_' + keyAddon}
                        formSelectOptionAsRadio={true}
                        entity={IDs.ENT_KONFIGURATION}
                        module={IDs.MOD_ETOOL}
                        extraFormElementAfter={{
                            externer_berater: beraterZugriff === 1
                                ? <div style={{ marginBottom: 20, marginLeft: 63 }}>
                                    <EinstellungBeraterButtonWrapper
                                        data={this.props.data}
                                        onRoutingChange={this.props.onRoutingChange}
                                    />
                                </div>
                                : <div style={{ height: 20 }} />
                        }}
                        directEditFormularOf={{ tid }}
                        inlineFormular={true}
                        customClass='Custom-ETA'
                        customFormConfig={customFormConfig}
                        customCssStyle={customCssStyle}
                        formPreset={formPreset}
                        validateField={this.customValidate}
                        formLayout='flowV2'
                        formLayout2='assistent'
                        formAutoSave={true}
                        formAutoSaveDisableOnUnmount={true}
                        disableFieldSelectDefaultOptions={{
                            vsme: true,
                            energiesteuerrueckerstattung: true,
                            alternatives_system: true,
                            anwendungskontext: true,
                            berater_zugriff: true,
                            co2_fussabdruck: true,
                            co2_fussabdruck_modus: true,
                            co2_fussabdruck_sachanlagen: true,
                            daten_elektrofahrzeuge: true,
                            daten_erneuerbare_energien: true,
                            daten_fahrzeuge: true,
                            daten_kraftstoffe_standort: true,
                            daten_maschinen: true,
                            daten_standorte_energietraeger: true,
                            daten_standorte_gebaeude: true,
                            daten_zustaendigkeiten: true,
                            etool_test: true,
                            gefuehrter_modus: true,
                            mehrere_standorte: true,
                            veranstaltungen: true,
                            start_hinweis: true,
                            unternehmensart: true,
                            vorsteuerabzugsberechtigt: true,
                        }}
                        onFormChange={(data: any) => {
                            const beraterZugriff = data.values.berater_zugriff;
                            if (tid > 0 && beraterZugriff !== this.state.beraterZugriff) {
                                this.dataService.saveData(IDs.ENT_KONFIGURATION, { tid, berater_zugriff: beraterZugriff }, null, null, () => {
                                    this.setState({ beraterZugriff });
                                }, IDs.MOD_ETOOL);
                            }
                        }}
                        onSaveDone={() => {
                            // In MainFilterLoader bekommt konfig.etool_test seinen Wert von regist.test_registrierung, es muss hier zuerst Registrierung neu laden.
                            this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG,
                                () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION));
                        }}
                        globalData={this.props.data}
                    />
                </div>
            </div>
        );
    }

    customValidate(key: string, value: any, dat: any, onValueChange: (name: string, value: any) => void): any {
        const bereichKey: string = this.apiService.getBereichKey();
        if (key === 'berater_zugriff') {
            if (bereichKey !== 'sonstige') {
                // WKETOOL-102: 453
                // Wenn man als Nutzer:in die Frage 'berater_zugriff' mit Nein beantwortet, 
                // dann wird die Berater:innen-Zuordnung automatisch gelöscht und es kommt kein Fehlerhinweis.
                const savedBerater = this.props.data.RES_MAIN_LOAD_BERATER;
                if (+value !== 1) {
                    if (Array.isArray(savedBerater) && savedBerater.length > 0) {
                        onValueChange(key, 1);
                        const info = 'Bitte entfernen Sie zunächst den bzw. die ausgewählten Berater!';
                        alert(info);
                    }
                }
            }
        }
        if (key === 'co2_fussabdruck') {
            if (value === null) {
                onValueChange(key, 2);
            }
        }
        if (key === 'daten_maschinen') {
            const as = dat.getValue('alternatives_system');
            if (+value !== 1 && +as === 1) {
                alert('Sie haben die Testierung  gemäß dem Alternativen System ausgewählt. ' +
                    'Hierfür ist die Erfassung Ihrer Maschinen/Anlagen zwingend erforderlich. ' +
                    'Die entsprechenden Konfigurations-Parameter wurden automatisch aktiviert.');
                onValueChange(key, 1);
            }
        }
        return undefined;
    };
}
